<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
<!--        <router-link :to="{ path: '/admin/article/list' }">-->
          <Button icon="ios-arrow-back" size="small" class="mr20" @click="fanhui()">返回</Button>
<!--        </router-link>-->
        <span class="ivu-page-header-title mr20" v-text="$route.params.id >0 ? '编辑'+this.title : '添加'+this.title"></span>
      </div>
    </div>
    <div class="myModal">
      <Form ref="artInfo"  :model='artInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <form-item label="标题" prop="article_title">
          <Input placeholder="请输入" v-model="artInfo.title"></Input>
        </form-item>
        <FormItem label="详情：" prop="article_info">
          <ueditor ref="ueDetail" :content="artInfo.content"></ueditor>
        </FormItem>

      </Form>
    </div>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </div>
</template>
<style>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { articleInfo, eidtArticle } from '@/api/article'
import ueditor from '@/components/ueditorFrom/index'
export default {
  name: 'listEdit',
  components: { ueditor },
  props: ['editShow', 'id'],
  data () {
    return {
      title: '资讯',
      editor: null,
      isShow: false,
      article_id: 0,
      artInfo: {
        id: 0,
        title: '',
        content: '',
        type: 2,
      },
      ruleValidate: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ]
      }
    }
  },
  // watch: {
  //   editShow (val) {
  //     this.isShow = val
  //       this.artInfo.article_id = 0
  //       this.artInfo.article_info = ''
  //       this.artInfo.article_title = ''
  //       this.artInfo.is_top = 0
  //   },
  //   id (val) {
  //     this.article_id = val
  //     if (this.article_id > 0) {
  //       this.articleInfo()
  //     }
  //   }
  // },
  created () {
    this.artInfo.id = 0
    this.artInfo.content = ''
    this.artInfo.title = ''
    this.articleInfo()
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel', false)
    },
    fanhui(){
      this.$router.push({ path: this.$router.go(-1) })
    },
    handleOk (name) {
      this.artInfo.content = this.$refs.ueDetail.contents
      let data = { 'id': this.artInfo.id,
        'title': this.artInfo.title,
        'content': this.artInfo.content,
        'type': this.artInfo.type,
      }

      this.$refs[name].validate(valid => {
        if (valid) {
          eidtArticle(data).then(res => {
            let msg = '添加成功'
            if (data.article_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$router.push({ path: this.$router.go(-1) })
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },
    articleInfo () {
      if (this.$route.params.id) {
        let data = { 'id': this.$route.params.id }
        articleInfo(data).then(res => {
          // console.log(res)
          this.artInfo = res.data
          this.$refs.ueDetail.contents = this.artInfo.content
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    }
  }
}
</script>
